import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import { connect } from 'react-redux';
import * as Constants from '../../utilities/constants/Constants';

class ToolbarItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isTooltipOpen: false,
      toolIndex: null
    };
  }

  hideOrShowTooltip = (showTooltip, index) => {
    this.setState({ isTooltipOpen: showTooltip, toolIndex: index });
  };

  render() {
    const { isTooltipOpen } = this.state;
    const {
      alignToolIsOpen,
      item,
      itemIndex,
      itemIsClicked,
      loadingState
    } = this.props;
    const { toolIndex } = this.state;

    let itemImage;
    switch (item.state) {
      case Constants.NORMAL_STATE:
        itemImage = item.icon_path;
        break;
      case Constants.SELECTED_STATE:
        itemImage = item.highlight_path;
        break;
      case Constants.DISABLED_STATE:
        itemImage = item.disabled_path;
        break;
      default:
        itemImage = item.icon_path;
        break;
    }

    if (itemIndex === toolIndex && item.state != Constants.DISABLED_STATE) {
      itemImage = item.highlight_path;
    }

    return (
      <div
        role='button'
        tabIndex='0'
        style={{ outline: 'none' }}
        onClick={e => {
          e.stopPropagation();
          this.hideOrShowTooltip(false, null);
          itemIsClicked(item);
        }}
        onKeyPress={() => {}}
        id={`toolbar-item-${item.alt}`}
        className='option-box d-flex justify-content-center align-items-center'
      >
        <img
          alt={item.alt}
          src={itemImage}
          id={`toolbar-${item.alt}`}
          onMouseLeave={() => {
            this.hideOrShowTooltip(false, null);
          }}
          onMouseEnter={() => {
            this.hideOrShowTooltip(true, itemIndex);
          }}
        />

        {loadingState === null ? ( // patch: target not found for tile and untile
          <Tooltip
            id='tooltip-inner'
            className='mb-3'
            isOpen={
              item.alt === 'align-icon' && alignToolIsOpen
                ? false
                : isTooltipOpen
            }
            placement='top'
            target={`toolbar-${item.alt}`}
          >
            {item.name}
          </Tooltip>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.home.language,
    loadingState: state.fabricCanvas.loadingState
  };
}

export default connect(mapStateToProps)(ToolbarItem);
